import { useEffect, useMemo, useState } from 'react';
import {
  getAuthModulosLicenca,
  getAuthModulosAtivos,
  getAuthEmpresasPermitidas,
} from '../services/authStorage';
import { isModuloAtivo, rotaExigeModulo, rotaPermitida } from '../utils/modulosLicenca';

export function useModulosLicenca() {
  const [tick, setTick] = useState(0);

  useEffect(() => {
    const onUpdate = () => setTick((v) => v + 1);
    window.addEventListener('zen:licenca-atualizada', onUpdate);
    return () => window.removeEventListener('zen:licenca-atualizada', onUpdate);
  }, []);

  const modulos = getAuthModulosLicenca();
  const modulosAtivos = getAuthModulosAtivos();
  const empresasPermitidas = getAuthEmpresasPermitidas();

  return useMemo(
    () => ({
      modulos,
      modulosAtivos,
      empresasPermitidas,
      isAtivo: (codigo) => isModuloAtivo(modulos, codigo),
      rotaPermitida: (pathname) => rotaPermitida(pathname, modulos),
      moduloDaRota: (pathname) => rotaExigeModulo(pathname),
    }),
    [modulos, modulosAtivos, empresasPermitidas, tick]
  );
}

export default useModulosLicenca;
